var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 4.29 4 8.58 4 13 C-0.29 13 -4.58 13 -9 13 C-8.67 11.35 -8.34 9.7 -8 8 C-5.69 8 -3.38 8 -1 8 C-1.020625 6.865625 -1.04125 5.73125 -1.0625 4.5625 C-1 1 -1 1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(52,43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5 3.31 5 5.62 5 8 C7.31 8 9.62 8 12 8 C12.33 9.65 12.66 11.3 13 13 C8.71 13 4.42 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(8,43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 4.29 13 8.58 13 13 C11.35 12.67 9.7 12.34 8 12 C8 9.69 8 7.38 8 5 C5.69 5 3.38 5 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(43,8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C12.67 1.65 12.34 3.3 12 5 C9.69 5 7.38 5 5 5 C5 7.31 5 9.62 5 12 C3.35 12.33 1.7 12.66 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(8,8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.7e74d394bba0d02c7b2bb8bc5c6cdb90.svg";
export { ForwardRef as ReactComponent };